var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel"},[_c('div',{staticClass:"title-banner"},[(_vm.title_show)?_c('span',{staticClass:"title"},[_vm._v("购买须知")]):_vm._e()]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.info.notice)}})])}
var staticRenderFns = []

export { render, staticRenderFns }